export default {
  methods: {
    getSearchParams (searchTerm) {
      return {
        'query': {
          'bool': {
            'should': [
              {
                'multi_match': {
                  'query': searchTerm,
                  'type': 'phrase',
                  'fields': [
                    'name',
                    'aliases.alias'
                  ],
                  'boost': 4
                }
              },
              {
                'multi_match': {
                  'query': searchTerm,
                  'type': 'phrase_prefix',
                  'fields': [
                    'name',
                    'aliases.alias'
                  ],
                  'max_expansions': 9999,
                  'boost': 3
                }
              },
              {
                'multi_match': {
                  'query': searchTerm,
                  'type': 'cross_fields',
                  'fields': [
                    'name',
                    'aliases.alias'
                  ],
                  'boost': 2
                }
              },
              {
                'multi_match': {
                  'query': searchTerm,
                  'type': 'most_fields',
                  'fields': [
                    'name',
                    'aliases.alias'
                  ],
                  'fuzziness': 'AUTO'
                }
              }
            ]
          }
        },
        'size': 10
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/business_search.js